import React from "react";

import { Box } from "@mui/material";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Service from "./components/Service";
import System from "./components/System";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import ScrollTopButton from "../../components/ScrollTopButton";

const index = () => {
  return (
    <React.Fragment>
      <Navbar />
      <Hero name={"Substance Abuse Unit"} />
      <About />
      <Service />
      <System />
      <Contact />

      <Footer />

      <ScrollTopButton />
    </React.Fragment>
  );
};

export default index;
